import { createSlice } from '@reduxjs/toolkit'
import { SCORE_MODE_ID } from '../../../../common/filterCompany/constant'
import { register } from '../../../../helpers/reducerRegistry'
import { getScoreDistribution } from './thunk'

const initialState = {
  creditRisk: [],
  performance: [],

  loading: true,
}

const slice = createSlice({
  name: 'portfolio/summary/scoreDistribution',
  initialState,
  reducers: {
    resetStore: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getScoreDistribution.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getScoreDistribution.fulfilled, (state, action) => {
      if (action.meta.arg.scoreModelId === SCORE_MODE_ID.CORPORATE_RISK) {
        state.creditRisk = action.payload || []
      } else {
        state.performance = action.payload || []
      }
      state.loading = false
    })
    builder.addCase(getScoreDistribution.rejected, (state, action) => {
      state.loading = action.payload.loading
    })
  },
})

export const selectCreditRisk = (state) => state[slice.name].creditRisk
export const selectPerformance = (state) => state[slice.name].performance

export const selectLoading = (state) => state[slice.name].loading

export const { resetStore } = slice.actions

register(slice.name, slice.reducer)
